module.exports = ({React,connect,ToolbarActions,ElementLabel})->

  class QuizTag extends React.Component

    constructor:(props)->
      super(props)
    
    render:->
      active = @props.isSelected && @props.textedit_active_node.type == "duoquiz"
      <quiz-tag {...@props.attributes} {...@props.props}></quiz-tag>
      
  connect((state)->
    toolbars_active:state.toolbars_active
    textedit_active_node:state.textedit_active_node
  )(QuizTag)